import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { Input, SquareButton } from 'components';
import { updatePanel, ThunkDispatch, refreshCurrentClient } from 'store';
import { useDispatch } from 'react-redux';
import { useFormikDispatchSubmit } from 'hooks/useFormikSubmit';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.borderRadius.std,
    border: `1px solid ${theme.colors.grayBorder}`,
    padding: theme.marginBase * 3,
    marginBottom: theme.marginBase * 2,
    '&:hover': {
      boxShadow: theme.boxShadow.base,
    },
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginRight: theme.marginBase * 4,
  },
  button: {
    marginLeft: theme.marginBase,
  },
  label: {
    ...theme.fonts.label,
  },
  membersCount: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  panelName: string;
  panelId: string;
  isEdition: boolean;
  setEdition: (state: boolean) => void;
}

interface FormValues {
  name: string;
}

const validationSchema = Yup.object().shape({ name: Yup.string().required() });

export const PanelSummary = ({
  panelName,
  panelId,
  isEdition,
  setEdition,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const dispatch = useDispatch<ThunkDispatch>();

  const initialValues = {
    name: panelName,
  };

  const updateCurrentPanel = (values: FormValues) => {
    return updatePanel(panelId, values);
  };
  const onSuccess = () => {
    dispatch(refreshCurrentClient());
    setEdition(false);
  };

  const submit = useFormikDispatchSubmit(updateCurrentPanel, { onSuccess });

  return (
    <div className={classes.container}>
      {isEdition ? (
        <>
          <div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={submit}
            >
              <Form>
                <div className={classes.inputContainer}>
                  <Input
                    name="name"
                    noMargin
                    small
                    autoFocus
                    className={classes.input}
                  />
                  <SquareButton
                    type="submit"
                    icon="ri-check-line"
                    color="green"
                    variant="muted"
                    className={classes.button}
                  />
                </div>
              </Form>
            </Formik>
          </div>
        </>
      ) : (
        <>
          <p className={classes.label}>{panelName}</p>
        </>
      )}
    </div>
  );
};
